import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-b8920902"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["src"]
const _hoisted_2 = { class: "podium-item__avatar" }
const _hoisted_3 = { class: "podium-item__avatar-border" }
const _hoisted_4 = ["src"]
const _hoisted_5 = { class: "podium-item__avatar-rank" }
const _hoisted_6 = { class: "podium-item__name" }
const _hoisted_7 = { class: "podium-item__score" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["podium-item", _ctx.modifierClass])
  }, [
    _createElementVNode("img", {
      class: "podium-item__crown",
      src: _ctx.crownIcon
    }, null, 8, _hoisted_1),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("img", { src: _ctx.avatar }, null, 8, _hoisted_4)
      ]),
      _createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.rank), 1)
    ]),
    _createElementVNode("div", _hoisted_6, _toDisplayString(_ctx.displayName), 1),
    _createElementVNode("div", _hoisted_7, _toDisplayString(_ctx.score), 1)
  ], 2))
}